import React, { memo, useRef, useEffect, useCallback, useState} from 'react';
import LinkedPolygon from './LinkedPolygon.js';
import {connect} from 'react-redux';
import {useParameterFinder} from './useParameterFinder.js';
import '../../Parameters.scss';

const LinkedParameterVisualizer = memo(({
    edgesSize,
    edgesPadding,
    scale=1,
    editorPadding,
    scrollContainer,
    destinationPosition,
    parameter,
    scrollHeight,
    sequencerEngine,
}) => { 
    let ref = useRef();
    if (parameter) {
        let fx = parameter.context.subDevice || parameter.context.effect || parameter.context.midiEffect;
    }
    let pts = useParameterFinder(parameter, scrollContainer, scale, destinationPosition);

    let style = {};
    useEffect(() => {
        let {edgesSize, editorPadding, edgesPadding} = sequencerEngine.state.spatial;
        ref.current.style.width = edgesSize.width +'px';
        ref.current.style.height = edgesSize.height + 'px';
        ref.current.style.minWidth = edgesSize.width +'px';
        ref.current.style.minHeight = edgesSize.height + 'px';
        ref.current.style.left = edgesPadding.x;
        ref.current.style.top = edgesPadding.y;
    }, [pts]);

    return (
        <svg style={style} ref={ref} className="parameter-link-visualizer">
          {pts && <LinkedPolygon points={pts} svgRef={ref}/>}
        </svg>);
    return [];
});

const mapStateToProps = (state, props) => {
    let position;
    let parameter = state.effects.accumulatorParameterSelected;
    if (parameter && parameter.context) {
        let fx = parameter.context.subDevice || parameter.context.effect || parameter.context.midiEffect;
        if (fx) {
            position = state.windows.windowPositions[fx.id];
        }
    }
    return {
        destinationPosition: position,
        parameter: parameter,
        // scrollHeight: props.scrollContainer.current && props.scrollContainer.current.scrollHeight,
        //editorPadding: state.spatial.editorPadding,
        //edgesSize: state.spatial.edgesSize,
        //edgesPadding: state.spatial.edgesPadding
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkedParameterVisualizer);
